import FilterMenuSearchExtended from "./FilterMenuSearchExtended";

export default FilterMenuSearchExtended;
